import { Download } from 'lucide-react';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { Pill } from '@/components/Pill';
import { Skeleton } from '@/components/Skeleton';
import * as shared from '../../tasks.css';
import * as styles from './sections.css';
import type { ReportingTaskFile } from './types';

type ArtifactsProps = {
    files: ReportingTaskFile[];
};

/**
 * The task's generated output files as downloadable pills, or an empty message
 * when nothing has been produced yet.
 */
export function Artifacts({ files }: ArtifactsProps) {
    return (
        <Flex direction="column" gap="2">
            <span className={shared.sectionLabel}>作成物</span>

            <Flex wrap="wrap" gap="2">
                {files.map((file) => (
                    <a key={file.downloadUrl} href={file.downloadUrl} download>
                        <Pill variant="quinary">
                            <Icon icon={Download} size="sm" />
                            {file.filename}
                        </Pill>
                    </a>
                ))}

                {files.length === 0 && <p className={styles.emptyMessage}>作成物はありません</p>}
            </Flex>
        </Flex>
    );
}

const SKELETON_FILE_COUNT = 2;

export function ArtifactsSkeleton() {
    return (
        <Flex direction="column" gap="2">
            <span className={shared.sectionLabel}>作成物</span>

            <Flex wrap="wrap" gap="2">
                {Array.from({ length: SKELETON_FILE_COUNT }).map((_, i) => (
                    // biome-ignore lint/suspicious/noArrayIndexKey: loading placeholder, files have no identity
                    <Skeleton.Box key={i} width={140} height={32} />
                ))}
            </Flex>
        </Flex>
    );
}
